// slide
import Splide from "@splidejs/splide";

const slide_atributos = new Splide("#slide-atributos", {
    type: "loop",
    perPage: 3,
    perMove: 1,
    autoplay: false,
    arrows: true,
    pagination: false,
    breakpoints: {
        992: {
            perPage: 4
        },
        768: {
            perPage: 3
        }
    }
}).mount();

slide_atributos.on("active", function (e) {
    const titulo = $(e.slide)
        .find(".slide-in")
        .data("titulo");
    const texto = $(e.slide)
        .find(".slide-in")
        .data("texto");
    const imagen = $(e.slide)
        .find(".slide-in")
        .data("imagen");
    $("#atributos")
        .find("h3")
        .html(titulo);
    $("#atributos")
        .find("p")
        .html(texto);
    $("#atributos")
        .find(".fondo")
        .css("background-image", `url(${imagen})`);
});

let slide_modelos = {};

modelos_todos = $.parseJSON(modelos_todos);
$.each(modelos_todos, function (id, tipo) {
    slide_modelos[`m${id}`] = new Splide(`#slide-modelos-${id}`, {
        type: "slide",
        perPage: 3,
        perMove: 1,
        autoplay: false,
        arrows: true,
        pagination: false,
        breakpoints: {
            992: {
                perPage: 2
            },
            576: {
                perPage: 1
            }
        }
    }).mount();
});

$(document).ready(function () {
    $('a[data-slide="slide-modelos"]').on("shown.bs.tab", function (e) {
        const id = $(this).data("id");
        slide_modelos[id].refresh();
    });
});

$(document).ready(function () {
    $('a[data-slide="tab-galeria"]').on("shown.bs.tab", function (e) {
        var id = $(this).data("id");

        if (id == "slide_galeria_departamentos") {
            slide_galeria_departamentos.refresh();
        }
        if (id == "slide_galeria_espacios") {
            slide_galeria_espacios.refresh();
        }
        if (id == "slide_galeria_entorno") {
            slide_galeria_entorno.refresh();
        }
    });
});


const slide_galeria = new Splide("#slide-galeria", {
    type: "slide",
    perPage: 3,
    perMove: 1,
    autoplay: false,
    arrows: true,
    pagination: false,
    breakpoints: {
        768: {
            perPage: 1
        }
    }
}).mount();

const slide_galeria_departamentos = new Splide("#slide-galeria-departamentos", {
    type: "slide",
    perPage: 3,
    perMove: 1,
    autoplay: false,
    arrows: true,
    pagination: false,
    breakpoints: {
        992: {
            perPage: 2
        },
        576: {
            perPage: 1
        }
    }
}).mount();

const slide_galeria_espacios = new Splide("#slide-galeria-espacios", {
    type: "slide",
    perPage: 3,
    perMove: 1,
    autoplay: false,
    arrows: true,
    pagination: false,
    breakpoints: {
        992: {
            perPage: 2
        },
        576: {
            perPage: 1
        }
    }
}).mount();

const slide_galeria_entorno = new Splide("#slide-galeria-entorno", {
    type: "slide",
    perPage: 3,
    perMove: 1,
    autoplay: false,
    arrows: true,
    pagination: false,
    breakpoints: {
        992: {
            perPage: 2
        },
        576: {
            perPage: 1
        }
    }
}).mount();


const slide_terraza = new Splide("#slide-terraza-imagenes", {
    type: "loop",
    perPage: 3,
    perMove: 1,
    autoplay: true,
    arrows: true,
    pagination: false,
    breakpoints: {
        992: {
            perPage: 3
        },
        768: {
            perPage: 2
        },
        540: {
            perPage: 1

        }
    }
}).mount();

var slide_terminaciones = new Splide("#slide-terminaciones", {
    type: "loop",
    perPage: 1,
    perMove: 1,
    autoplay: true,
    arrows: false,
    pagination: false,
}).mount();

// const slide_gym = new Splide("#slide-gym-imagenes", {
//     type: "loop",
//     perPage: 3,
//     perMove: 1,
//     autoplay: true,
//     arrows: true,
//     pagination: false,
//     breakpoints: {
//         992: {
//             perPage: 3
//         },
//         768: {
//             perPage: 2
//         },
//         540: {
//             perPage: 1

//         }
//     }
// }).mount();
